<template>
  <div class="main-screen-x">
    <div class="title-bar">
      <div class="app-title">
        Netwrix Auditor
      </div>
      <div class="app-actions">
        <div class="action-item">
          <div class="icon-customize"></div>
          Customize
        </div>
        <div class="action-item">
          <div class="icon-settings"></div>
          Settings
        </div>
        <div class="action-item">
          <div class="icon-help"></div>
          Help
        </div>
      </div>
    </div>
    <div class="app-screen">
      <div class="app-left-column">
        <div class="section-configuration section-disabled">
          <div class="section-title">
            CONFIGURATION
          </div>
          <ul>
            <li class="disabled">
              Monitoring plans
            </li>
            <li class="disabled">
              Subscriptions
            </li>
            <li class="disabled">
              All Alerts
            </li>
          </ul>
        </div>
        <div class="section-graphs section-disabled">
          <div class="section-title">
            ENTERPRISE: FAILED ACTIVITY TREND
          </div>
          <div class="section-content">
            <div class="graph-axises">
              <div class="legend">
                <div class="ad-label">Active Directory</div>
                <div class="sql-label">SQL Servers</div>
                <div class="fs-label">File Servers</div>
              </div>
              <div class="text-label-1">
                1765
              </div>
              <div class="text-label-2">
                0
              </div>
              <div class="text-label-3">
                9/1/2021
              </div>
              <div class="text-label-4">
                9/7/2021
              </div>
              <div class="text-label-5">
                9/15/2021
              </div>
              <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/graphs.svg" alt="Graph image">
            </div>
          </div>
        </div>
        <div class="section-risk-assessment section-disabled">
          <div class="section-title">
            Risk assessment
          </div>
          <div class="section-content">
            <img
              class="risk-assessment-icon"
              src="//img.netwrix.com/elements/onlineDemo/ui_icons/x/risk-assessment-icon.svg"
              alt="Risk Assessment icon"
            >
            <span>Take action</span>
          </div>
        </div>
      </div>
      <div class="app-right-column">
        <div class="section-favorite">
          <div class="section-title">
            FAVORITE REPORTS
          </div>
          <ul>
            <li class="disabled">
              Enterprise Overview
            </li>
            <li class="disabled">
              Activity outside business hours
            </li>
            <li class="disabled">
              User account status changes
            </li>
            <li class="disabled">
              Failed Activity Trend
            </li>
            <li class="disabled">
              File and Folder Permissions Details
            </li>
            <li class="disabled">
              Logons by Single User from Multiple Endpoints
            </li>
            <li class="disabled">
              Objects Shared with External or Anonymous Users
            </li>
          </ul>
          <div>
            <span
              :class="{'view-all-link': true, 'scenario-link': currentStep === 0}"
              @click="currentStep === 0 ? $root.$emit(EVENT_NEXT_STEP) : false"
            >
              View all
            </span>
          </div>
        </div>
        <div class="section-search-uba">
          <div class="section-disabled">
            <div class="section-title">Search<br> activity</div>
            <img
              class="search-icon"
              src="//img.netwrix.com/elements/onlineDemo/ui_icons/x/search-icon.svg"
              alt="Search icon"
            >
          </div>
          <div class="section-disabled">
            <div class="section-title">Behavior<br> anomalies</div>
            <img
              class="anomalies-icon"
              src="//img.netwrix.com/elements/onlineDemo/ui_icons/x/anomalies-icon.svg"
              alt="Anomalies icon"
            >
          </div>
        </div>
        <div class="section-alerts section-disabled">
          <div class="section-title">
            ALERTS
          </div>
          <div class="section-content">
            <div class="triggered-text">Triggered</div>
            <div class="triggered-value">534</div>
            <div class="triggered-diff-text"><span>+25%</span> over previous 7 days</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex';

  import spacers from '@/mixins/spacers';
  import { EVENT_SET_STEP, EVENT_NEXT_STEP } from '@/constants';

  export default {
    name: 'main-screen-x',
    mixins: [spacers],
    data() {
      return {
        currentLeftSpacer: '',
        currentRightSpacer: '',
        EVENT_NEXT_STEP,
      };
    },
    computed: {
      ...mapState('guide', ['currentScenarioId', 'currentStep']),
    },
    methods: {
      click(step, scenario) {
        if (scenario) {
          window.location.href = '/product_online_demo.html?scenario=' + scenario;
          return;
        }
        (step) ? this.$root.$emit(EVENT_SET_STEP, step) : '';
      },
    },
  };
</script>

<style lang="less" scoped>
  .main-screen-x {
    font-family: 'Segoe UI', sans-serif;
    padding: 64px 459px 0 22px;

    .icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }

    .section {
      width: 100%;
      margin-bottom: 20px;
      border: 1px solid #D9DEE2;
      padding: 18px 23px;

      .section-title {
        font-size: 14px;
        line-height: 19px;
        color: #4B5053;
        margin-bottom: 21px;
        text-transform: uppercase;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          font-size: 14px;
          line-height: 32px;
          color: #0D71B9;

          &.disabled {
            color: #A4ABB1;
          }
        }
      }

      .scenario-link {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      &.section-disabled {
        opacity: 0.5;
      }

      &.section-clickable {

        &:not(.section-disabled) {
          cursor: pointer;

          &:hover {
            border: 1px solid #0D71B9;
          }
        }
      }
    }

    .icon-customize {
      .icon();
      background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/x/customize-icon.svg') center no-repeat;
    }

    .icon-settings {
      .icon();
      background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/x/settings-icon.svg') center no-repeat;
    }

    .icon-help {
      .icon();
      background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/x/help-icon.svg') center no-repeat;
    }

    .title-bar {
      display: flex;
      justify-content: space-between;
      margin-bottom: 29px;

      .app-title {
        font-style: normal;
        font-weight: 350;
        font-size: 21px;
        line-height: 28px;
        color: #0D71B9;
      }

      .app-actions {
        display: flex;

        .action-item {
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 0;
          color: #0D71B9;
          display: flex;
          align-items: center;
          margin-right: 28px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .app-screen {
      display: flex;
      width: 965px;
      justify-content: space-between;

      .app-left-column {
        width: 450px;

        .section-configuration {
          .section();
          height: 177px;
        }

        .section-graphs {
          .section();
          padding: 16px 25px;
          height: 240px;

          .section-content {

            .graph-axises {
              position: relative;
              top: 13px;
              left: 30px;
              width: 361px;
              height: 128px;
              border-left: 1px solid #E8ECF0;
              border-bottom: 1px solid #E8ECF0;

              .legend {
                position: absolute;
                top: -7px;
                left: 10px;
                display: flex;

                & > div {
                  font-size: 14px;
                  line-height: 19px;
                  align-items: flex-end;
                  color: #121212;
                  margin-right: 10px;

                  &:before {
                    content: '';
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #329DEF;
                    margin-right: 7px;
                  }

                  &.sql-label:before {
                    background: #C5D986;
                  }

                  &.fs-label:before {
                    background: #9DAEDD;
                  }
                }
              }

              img {
                position: absolute;
                bottom: -3px;
                left: 4px;
              }
            }

            .text-label {
              font-family: 'Open Sans', sans-serif;
              position: absolute;
              font-size: 11px;
              line-height: 15px;
              text-align: center;
              color: #91959A;
            }

            .text-label-1 {
              .text-label();
              top: 26px;
              left: -40px;
            }

            .text-label-2 {
              .text-label();
              top: 110px;
              left: -29px;
            }

            .text-label-3 {
              .text-label();
              top: 137px;
              left: 12px;
            }

            .text-label-4 {
              .text-label();
              top: 137px;
              left: 159px;
            }

            .text-label-5 {
              .text-label();
              top: 137px;
              left: 300px;
            }
          }
        }

        .section-risk-assessment {
          .section();
          padding: 8px 17px;
          height: 96px;

          .section-content {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .risk-assessment-icon {
              position: relative;
              top: -3px;
            }
          }
        }
      }

      .app-right-column {
        width: 495px;

        .section-favorite {
          .section();
          padding: 18px 26px;
          height: 324px;

          .section-title {
            margin-bottom: 16px;
          }

          ul {
            li {

              &:before {
                position: relative;
                top: 1px;
                display: inline-block;
                width: 10px;
                height: 13px;
                content: '';
                background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/x/report-icon.svg') center no-repeat;
                margin-right: 8px;
              }
            }
          }

          .view-all-link {
            color: #0D71B9;
          }
        }

        .section-search-uba {
          display: flex;
          justify-content: space-between;

          & > div {
            .section();
            position: relative;
            padding: 8px 15px;
            width: 235px;
            height: 93px;

            &:nth-child(2) {
              width: 240px;
            }

            img {
              position: absolute;
              top: 13px;
              right: 36px;
            }
          }
        }

        .section-alerts {
          .section();
          padding: 7px 12px;
          height: 96px;

          .section-content {
            display: flex;
            align-items: center;
            padding: 12px 4px;

            .triggered-text {
              font-size: 12px;
              line-height: 16px;
              text-transform: uppercase;
              color: #91959A;
              margin-right: 12px;
            }

            .triggered-value {
              font-size: 17px;
              line-height: 23px;
              margin-right: 59px;
            }

            .triggered-diff-text {
              font-size: 14px;
              line-height: 19px;
              color: #91959A;

              span {
                color: rgba(236, 3, 3, 0.5);
              }
            }
          }
        }
      }
    }
  }
</style>
